module.exports = __webpack_public_path__ + "img/img_product_FGF_2.3dd74a0b.jpg";